import { render } from "./StatusCheckBox.vue?vue&type=template&id=1a96926a&scoped=true"
import script from "./StatusCheckBox.vue?vue&type=script&lang=js"
export * from "./StatusCheckBox.vue?vue&type=script&lang=js"

import "./StatusCheckBox.vue?vue&type=style&index=0&id=1a96926a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a96926a"]])

export default __exports__